import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation } from '@tanstack/react-query';
// utils
import { formatDate } from 'utils';
// Forms
import contactPhoneFormValidation from '../../../forms/ContactPhoneForm/ContactPhoneFormValidation';

// Services
import { sendContact, useHourCallBackRanges } from '../../../src/services/contact';

function ContactPhone({ children }) {
  const { push } = useRouter();
  useHourCallBackRanges();

  const {
    handleSubmit,
    control,
    register,
    formState: { errors },
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      contactMode: 'phone',
      firstName: '',
      lastName: '',
      phone: null,
      email: '',
      dateCallBack: '',
      hourCallBackRangeCode: '',
      newsletter: false,
    },
    mode: 'onChange',
    resolver: yupResolver(contactPhoneFormValidation),
  });

  const { mutate, isLoading } = useMutation({
    mutationFn: sendContact,
    mutationKey: 'sendContactCall',
    onSuccess: () => {
      reset();
      push('/contact/call');
    },
  });

  const onSubmit = async (data) => {
    const message = { ...data, dateCallBack: formatDate(data.dateCallBack, 'yyyy-MM-dd') };
    mutate(message);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {children(control, register, errors, setValue, isLoading)}
    </form>
  );
}

ContactPhone.propTypes = {
  children: PropTypes.func.isRequired,
};

export default ContactPhone;
